/**
 * Created by Fatih on 30.06.2016.
 */
import $ from 'jquery';
import { replace, basePathname } from './store/history.js';

const $privacyPolicyPage = $('.privacy-menu');

function setPrivacyPolicyPageActive(bool) {
	if (bool) {
		$privacyPolicyPage.addClass('menu--is-open');
		setTimeout(() => {
			$privacyPolicyPage.css('transform', 'initial');
			//this part is for smooth scrolling in iOS
			$('.tabs-container').addClass('u-dn');
			if (window.location.href.indexOf('shop') !== -1) {
				$('.pusher').children().each(function () {
					$(this).addClass('u-dn');
				});
			}
		}, 500);
	} else {
		$privacyPolicyPage.removeClass('menu--is-open');
		$privacyPolicyPage.removeAttr('style');
		//this part is for smooth scrolling in iOS
		$('.tabs-container').removeClass('u-dn');
		if (window.location.href.indexOf('shop') !== -1) {
			$('.pusher').children().each(function () {
				$(this).removeClass('u-dn');
			});
		}
	}
}

$privacyPolicyPage.find('.icon-close').click(() => {
	//var router = require('./router');
	replace(basePathname());
});

export default {
	setPrivacyPolicyPageActive
};



// WEBPACK FOOTER //
// ./mobile-core/src/privacy-policy.js